/**
 * Drop Figma exports into `src/genius/assets/icons/registration/`.
 * Filenames below must match exactly. Components fall back to inline SVG if missing.
 */
export const REGISTRATION_ICON_FILES = {
  joinStudent: "join-student.svg",
  joinSchool: "join-school.svg",
  successBadge: "success-badge.svg",
  editPhone: "edit-phone.svg",
  close: "close.svg"
};

const iconUrl = (fileName) =>
  new URL(`../assets/icons/registration/${fileName}`, import.meta.url).href;

export const registrationIconUrls = Object.fromEntries(
  Object.entries(REGISTRATION_ICON_FILES).map(([key, file]) => [key, iconUrl(file)])
);
